import React from 'react';
import './FormField.scss';
import FormTimePicker from './FormTimePicker';
import { TimeValue } from '../date-range-picker/types';

interface TimeFormFieldProps {
    label?: string;
    name: string;
    value: TimeValue | null;
    onChange: (name: string, value: TimeValue | null) => void;
    helpText?: string;
    containerClassName?: string;
    error?: string;
    required?: boolean;
    disabled?: boolean;
}

const TimeFormField: React.FC<TimeFormFieldProps> = ({
    label,
    name,
    value,
    onChange,
    helpText,
    containerClassName = '',
    error,
    required = false,
    disabled = false,
}) => {
    const hasError = !!error;

    const handleTimeChange = (time: TimeValue) => {
        onChange(name, time);
    };

    return (
        <div className={`form-field ${containerClassName}`}>
            <div className='field-container'>
                {label && (
                    <label htmlFor={name} className='field-label'>
                        {label} {required && <span className={`required-indicator  ${hasError ? 'error' : ''}`}>*</span>}
                    </label>
                )}
                <div className='input-wrapper'>
                    <FormTimePicker
                        timeValue={value}
                        onTimeChange={handleTimeChange}
                        disabled={disabled}
                    />
                </div>
            </div>
            <span className={`help-text ${hasError ? 'error' : ''}`}>{error || helpText || ''}</span>
        </div>
    );
};

export default TimeFormField;
